
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { makeUseVisualState } from '../../motion/utils/use-visual-state.mjs.js';
import { scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs.js';
import { createHtmlRenderState } from './utils/create-render-state.mjs.js';

var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState,
    }),
};

export { htmlMotionConfig };
//# sourceMappingURL=config-motion.mjs.js.map
